import { render, staticRenderFns } from "./SelectPortPopup.vue?vue&type=template&id=0b96e9bc&scoped=true"
import script from "./SelectPortPopup.vue?vue&type=script&lang=js"
export * from "./SelectPortPopup.vue?vue&type=script&lang=js"
import style0 from "./SelectPortPopup.vue?vue&type=style&index=0&id=0b96e9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96e9bc",
  null
  
)

export default component.exports